<template>
    <v-layout row wrap align-start justify-center>
        
        <v-flex d-flex :class="attributes.size">
               
            <multiimageupload 
                :attributes="attributes" 
                :parent_id="parent_id"
                :itemsnamespace="itemsnamespace"
                :item="loaditem"
                :paths="paths"
                v-model="result">
            </multiimageupload>
        </v-flex>
        <v-flex xs12><v-divider class="my-4 black"></v-divider></v-flex>
        
    </v-layout>    
</template>

<script>
    import FormMultiImageUpload from './FormMultiImageUpload.vue'
    export default {
        name: 'formmediaupload',
        props:[
            'attributes',
            'vuexnamespace',            
        ],
        data () {
            return {                
                parent_id: this.$route.params.id, 
                loaditem:undefined,
                paths: this.$store.getters['shared/paths']
            }
        },
        
        components: {
            multiimageupload: FormMultiImageUpload
        },
        computed:{
            result: {
                get(){
                    return this.$store.getters[this.vuexnamespace + '/data'](this.attributes.variable)
                },
                set(value) {
                    this.$store.commit(this.attributes.setter, value)
                }
            },  
            itemsnamespace (){return this.attributes.items.split('/')[0]},
        },

        watch:{
            
            $route: function(to,from) {
                if(typeof this.$route.params.id != "undefined") {
                    this.parent_id = this.$route.params.id               
                } else {
                    this.parent_id=undefined               
                }            
            },
            
        },
        methods: {
            
        }
    }
</script>
    